import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" 엔젤리그 팩토리의 ")
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" 한정판 NFT 컬렉션! ")
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" NFT 사러 가기 > ")

import {toRefs} from 'vue'
import {Plugins} from '@capacitor/core'
import {AgBoxS} from '@/components/ag'
import logo from './assets/logo.pure.svg'
import {cookieSoftStorage} from '@/utils/storage'
import backGroundPng from './assets/back-ground.png'
import backGround2Png from './assets/back-ground@2x.png'
import backGround3Png from './assets/back-ground@3x.png'
import SOLSvg from './assets/SOL.pure.svg'


export default /*#__PURE__*/_defineComponent({
  props: {
  screenName: {default: 'unknown', type: String},
  url: {default: '', type: String},
},
  setup(__props) {

const props = __props



const {url} = toRefs(props)

const {Browser} = Plugins
const goUrl = (url: string) => {
  return Browser.open({url})
}
const saveTokenCookie = () => {
  cookieSoftStorage.setItem('token', {
    value: localStorage.getItem('token'),
  }, {
    domain: 'angelleague.io',
    secure: true,
  })
}
const goNftSite = () => {
  saveTokenCookie()
  goUrl(url.value)
}


return (_ctx: any,_cache: any) => {
  const _directive_track = _resolveDirective("track")!

  return _withDirectives((_openBlock(), _createBlock(_unref(AgBoxS), {
    css: {
      cursor: 'pointer',
      width: '100%',
      bg: 'white',
      position: 'relative',
      height: 153,
      p: 16,
      dp: 'flex',
      direction: 'row',
      corner: 10,
      overflow: 'hidden',
    },
    onClick: _cache[0] || (_cache[0] = ($event: any) => (goNftSite()))
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(AgBoxS), {
        "container-as": "img",
        src: _unref(backGroundPng),
        srcset: `${_unref(backGroundPng)} 1x, ${_unref(backGround2Png)} 2x, ${_unref(backGround3Png)} 3x`,
        css: {position: 'absolute', width: '100%', height: '100%', top: 0, left: 0, objectFit: 'cover'}
      }, null, 8, ["src", "srcset"]),
      _createVNode(_unref(AgBoxS), { css: {
        dp: 'flex',
        direction: 'column',
        grow: 1,
      } }, {
        default: _withCtx(() => [
          _createVNode(_unref(AgBoxS), {
            "container-as": "img",
            src: _unref(logo),
            css: {width: 92, height: 21, mb: 11}
          }, null, 8, ["src"]),
          _createVNode(_unref(AgBoxS), { css: {color: 'white', typography: 'h9'} }, {
            default: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1
          }),
          _createVNode(_unref(AgBoxS), { css: {typography: 'main14r', color: 'white', typography: 'h5', mb: 6} }, {
            default: _withCtx(() => [
              _hoisted_2
            ]),
            _: 1
          }),
          _createVNode(_unref(AgBoxS), { css: {typography: 'main14r', color: 'white', fontWeight: 800, typography: 'h7'} }, {
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_unref(AgBoxS))
    ]),
    _: 1
  }, 512)), [
    [_directive_track, {clickArea: 'NFT 배너', clickContent: 'NFT 배너'}]
  ])
}
}

})